import {StattedPoint} from "sandy-shared/dist/types/statted-point.type";
import {ServeInPlayLocation, ServeOutLocation, ServiceOutcome} from "sandy-shared/dist/types/servce-info.type";
import {AttackOriginLocation, AttackOutcome, AttackOutLocation, AttackType, AttackDestinationLocation, PassType} from "sandy-shared/dist/types/attack-info.type";
import {PartnershipWithState} from "../pages/matches/MatchStattingPage-types";

export const serveInNetPoint = (
  pointIndex: number,
  servingPartnership: PartnershipWithState,
  receivingPartnership: PartnershipWithState,
  servingPlayerId: number
) => {
  const point: StattedPoint = {
    pointIndex,
    servingPartnershipId: servingPartnership.id,
    receivingPartnershipId: receivingPartnership.id,
    serverPlayerId: servingPlayerId,
    serveInfo: {
      outcome: ServiceOutcome.Error,
      outLocation: ServeOutLocation.Net
    },
    winningPartnershipId: receivingPartnership.id
  };
  return point;
}

export const serveFaultPoint = (
  pointIndex: number,
  servingPartnership: PartnershipWithState,
  receivingPartnership: PartnershipWithState,
  servingPlayerId: number
) => {
  const point: StattedPoint = {
    pointIndex,
    servingPartnershipId: servingPartnership.id,
    receivingPartnershipId: receivingPartnership.id,
    serverPlayerId: servingPlayerId,
    serveInfo: {
      outcome: ServiceOutcome.Error,
      outLocation: ServeOutLocation.Fault
    },
    winningPartnershipId: receivingPartnership.id
  };
  return point;
}

export const serveOutPoint = (
  pointIndex: number,
  servingPartnership: PartnershipWithState,
  receivingPartnership: PartnershipWithState,
  servingPlayerId: number,
  serveOutLocation: ServeOutLocation
) => {
  const point: StattedPoint = {
    pointIndex,
    servingPartnershipId: servingPartnership.id,
    receivingPartnershipId: receivingPartnership.id,
    serverPlayerId: servingPlayerId,
    serveInfo: {
      outcome: ServiceOutcome.Error,
      outLocation: serveOutLocation
    },
    winningPartnershipId: receivingPartnership.id
  };
  return point;
}

export const acePoint = (
  pointIndex: number,
  servingPartnership: PartnershipWithState,
  receivingPartnership: PartnershipWithState,
  servingPlayerId: number,
  serveInPlayLocation: ServeInPlayLocation
) => {
  const point: StattedPoint = {
    pointIndex,
    servingPartnershipId: servingPartnership.id,
    receivingPartnershipId: receivingPartnership.id,
    serverPlayerId: servingPlayerId,
    serveInfo: {
      outcome: ServiceOutcome.Ace,
      inPlayLocation: serveInPlayLocation,
      receivingPlayerId: receivingPartnership.playerOne.side === serveInPlayLocation.side ? receivingPartnership.playerOne.id : receivingPartnership.playerTwo.id
    },
    winningPartnershipId: servingPartnership.id
  };
  return point;
}

export const blockKillPoint = (
  pointIndex: number,
  servingPartnership: PartnershipWithState,
  receivingPartnership: PartnershipWithState,
  servingPlayerId: number,
  serveInPlayLocation: ServeInPlayLocation,
  passType: PassType,
  attackType: AttackType,
  attackOriginLocation: AttackOriginLocation
) => {
  const receivingPlayerId = getReceivingPlayerId(receivingPartnership, serveInPlayLocation);
  const point: StattedPoint = {
    pointIndex,
    servingPartnershipId: servingPartnership.id,
    receivingPartnershipId: receivingPartnership.id,
    serverPlayerId: servingPlayerId,
    serveInfo: {
      outcome: ServiceOutcome.Received,
      inPlayLocation: serveInPlayLocation,
      receivingPlayerId
    },
    attackInfo: {
      attackingPlayerId: receivingPlayerId,
      passType,
      isOnTwo: false,
      originLocation: attackOriginLocation,
      attackType,
      outcome: AttackOutcome.BlockKill,
    },
    winningPartnershipId: servingPartnership.id
  };
  return point;
}

export const toolKillPoint = (
    pointIndex: number,
    servingPartnership: PartnershipWithState,
    receivingPartnership: PartnershipWithState,
    servingPlayerId: number,
    serveInPlayLocation: ServeInPlayLocation,
    passType: PassType,
    attackOriginLocation: AttackOriginLocation
) => {
  const receivingPlayerId = getReceivingPlayerId(receivingPartnership, serveInPlayLocation);
  const point: StattedPoint = {
    pointIndex,
    servingPartnershipId: servingPartnership.id,
    receivingPartnershipId: receivingPartnership.id,
    serverPlayerId: servingPlayerId,
    serveInfo: {
      outcome: ServiceOutcome.Received,
      inPlayLocation: serveInPlayLocation,
      receivingPlayerId
    },
    attackInfo: {
      attackingPlayerId: receivingPlayerId,
      isOnTwo: false,
      passType,
      originLocation: attackOriginLocation,
      attackType: AttackType.Swing,
      outcome: AttackOutcome.ToolKill,
    },
    winningPartnershipId: receivingPartnership.id
  };
  return point;
}

export const attackKillPoint = (
  pointIndex: number,
  servingPartnership: PartnershipWithState,
  receivingPartnership: PartnershipWithState,
  servingPlayerId: number,
  serveInPlayLocation: ServeInPlayLocation,
  passType: PassType,
  attackType: AttackType,
  attackOriginLocation: AttackOriginLocation,
  attackDestinationLocation: AttackDestinationLocation
) => {
  const receivingPlayerId = getReceivingPlayerId(receivingPartnership, serveInPlayLocation);
  const point: StattedPoint = {
    pointIndex,
    servingPartnershipId: servingPartnership.id,
    receivingPartnershipId: receivingPartnership.id,
    serverPlayerId: servingPlayerId,
    serveInfo: {
      outcome: ServiceOutcome.Received,
      inPlayLocation: serveInPlayLocation,
      receivingPlayerId
    },
    attackInfo: {
      attackingPlayerId: receivingPlayerId,
      isOnTwo: false,
      passType,
      originLocation: attackOriginLocation,
      attackType,
      outcome: AttackOutcome.InKill,
      destinationLocation: attackDestinationLocation
    },
    winningPartnershipId: receivingPartnership.id
  };
  return point;
}

export const attackInNetPoint = (
  pointIndex: number,
  servingPartnership: PartnershipWithState,
  receivingPartnership: PartnershipWithState,
  servingPlayerId: number,
  serveInPlayLocation: ServeInPlayLocation,
  passType: PassType,
  attackType: AttackType,
  attackOriginLocation: AttackOriginLocation
) => {
  const receivingPlayerId = getReceivingPlayerId(receivingPartnership, serveInPlayLocation);
  const point: StattedPoint = {
    pointIndex,
    servingPartnershipId: servingPartnership.id,
    receivingPartnershipId: receivingPartnership.id,
    serverPlayerId: servingPlayerId,
    serveInfo: {
      outcome: ServiceOutcome.Received,
      inPlayLocation: serveInPlayLocation,
      receivingPlayerId
    },
    attackInfo: {
      attackingPlayerId: receivingPlayerId,
      isOnTwo: false,
      passType,
      originLocation: attackOriginLocation,
      attackType,
      outcome: AttackOutcome.Out,
      outLocation: AttackOutLocation.Net
    },
    winningPartnershipId: servingPartnership.id
  };
  return point;
}

export const attackOutPoint = (
  pointIndex: number,
  servingPartnership: PartnershipWithState,
  receivingPartnership: PartnershipWithState,
  servingPlayerId: number,
  serveInPlayLocation: ServeInPlayLocation,
  passType: PassType,
  attackType: AttackType,
  attackOriginLocation: AttackOriginLocation,
  attackOutLocation: AttackOutLocation
) => {
  const receivingPlayerId = getReceivingPlayerId(receivingPartnership, serveInPlayLocation);
  const point: StattedPoint = {
    pointIndex,
    servingPartnershipId: servingPartnership.id,
    receivingPartnershipId: receivingPartnership.id,
    serverPlayerId: servingPlayerId,
    serveInfo: {
      outcome: ServiceOutcome.Received,
      inPlayLocation: serveInPlayLocation,
      receivingPlayerId
    },
    attackInfo: {
      attackingPlayerId: receivingPlayerId,
      isOnTwo: false,
      passType,
      originLocation: attackOriginLocation,
      attackType,
      outcome: AttackOutcome.Out,
      outLocation: attackOutLocation
    },
    winningPartnershipId: servingPartnership.id
  };
  return point;
}

export const faultPoint = (
  pointIndex: number,
  servingPartnership: PartnershipWithState,
  receivingPartnership: PartnershipWithState,
  servingPlayerId: number,
  serveInPlayLocation: ServeInPlayLocation,
  passType: PassType,
  attackOriginLocation: AttackOriginLocation,
  winningPartnershipId: number
) => {
  const receivingPlayerId = getReceivingPlayerId(receivingPartnership, serveInPlayLocation);
  const point: StattedPoint = {
    pointIndex,
    servingPartnershipId: servingPartnership.id,
    receivingPartnershipId: receivingPartnership.id,
    serverPlayerId: servingPlayerId,
    serveInfo: {
      outcome: ServiceOutcome.Received,
      inPlayLocation: serveInPlayLocation,
      receivingPlayerId
    },
    attackInfo: {
      attackingPlayerId: receivingPlayerId,
      isOnTwo: false,
      passType,
      originLocation: attackOriginLocation,
      outcome: AttackOutcome.Fault,
    },
    winningPartnershipId
  };
  return point;
}

export const blockCoveredTransitionPoint = (
  pointIndex: number,
  servingPartnership: PartnershipWithState,
  receivingPartnership: PartnershipWithState,
  servingPlayerId: number,
  serveInPlayLocation: ServeInPlayLocation,
  passType: PassType,
  attackType: AttackType,
  attackOriginLocation: AttackOriginLocation,
  winningPartnershipId: number
) => {
  const receivingPlayerId = getReceivingPlayerId(receivingPartnership, serveInPlayLocation);
  const point: StattedPoint = {
    pointIndex,
    servingPartnershipId: servingPartnership.id,
    receivingPartnershipId: receivingPartnership.id,
    serverPlayerId: servingPlayerId,
    serveInfo: {
      outcome: ServiceOutcome.Received,
      inPlayLocation: serveInPlayLocation,
      receivingPlayerId
    },
    attackInfo: {
      attackingPlayerId: receivingPlayerId,
      isOnTwo: false,
      passType,
      originLocation: attackOriginLocation,
      attackType,
      outcome: AttackOutcome.BlockRecycle,
    },
    winningPartnershipId
  };
  return point;
}

export const dugTransitionPoint = (
  pointIndex: number,
  servingPartnership: PartnershipWithState,
  receivingPartnership: PartnershipWithState,
  servingPlayerId: number,
  serveInPlayLocation: ServeInPlayLocation,
  passType: PassType,
  attackType: AttackType,
  attackOriginLocation: AttackOriginLocation,
  attackDestinationLocation: AttackDestinationLocation,
  winningPartnershipId: number
) => {
  const receivingPlayerId = getReceivingPlayerId(receivingPartnership, serveInPlayLocation);
  const point: StattedPoint = {
    pointIndex,
    servingPartnershipId: servingPartnership.id,
    receivingPartnershipId: receivingPartnership.id,
    serverPlayerId: servingPlayerId,
    serveInfo: {
      outcome: ServiceOutcome.Received,
      inPlayLocation: serveInPlayLocation,
      receivingPlayerId
    },
    attackInfo: {
      attackingPlayerId: receivingPlayerId,
      isOnTwo: false,
      passType,
      originLocation: attackOriginLocation,
      attackType: attackType,
      outcome: AttackOutcome.Dug,
      destinationLocation: attackDestinationLocation
    },
    winningPartnershipId
  };
  return point;
}

export const freeBallTransitionPoint = (
  pointIndex: number, 
  servingPartnership: PartnershipWithState,
  receivingPartnership: PartnershipWithState,
  servingPlayerId: number,
  serveInPlayLocation: ServeInPlayLocation,
  passType: PassType,
  winningPartnershipId: number
) => {
  const receivingPlayerId = getReceivingPlayerId(receivingPartnership, serveInPlayLocation);
  const point: StattedPoint = {
    pointIndex,
    servingPartnershipId: servingPartnership.id,
    receivingPartnershipId: receivingPartnership.id,
    serverPlayerId: servingPlayerId,
    serveInfo: {
      outcome: ServiceOutcome.Received,
      inPlayLocation: serveInPlayLocation,
      receivingPlayerId
    },
    attackInfo: {
      attackingPlayerId: receivingPlayerId,
      isOnTwo: false,
      passType,
      outcome: AttackOutcome.FreeBall
    },
    winningPartnershipId
  };
  return point;
}

const getReceivingPlayerId = (receivingPartnership: PartnershipWithState, serveInPlayLocation: ServeInPlayLocation) => {
  return receivingPartnership.playerOne.side === serveInPlayLocation.side ? receivingPartnership.playerOne.id : receivingPartnership.playerTwo.id;
}